<template>
    <newForm v-bind:title='$t("home_menu_management.home_ui_setting")' className="col-xs-12">
        <div class="row">
            <div class="col-md-12">
                <p>
                    {{$t("home_menu_management.description")}}
                    <hr />
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <label class="radio">
                    <strong>{{$t("home_menu_management.items_menu")}}</strong>
                </label>
                <tree hasContextMenu="false"
                      v-bind:data="dataTree"
                      v-bind:template="treeTemp"
                      v-bind:nodeSelect="nodeSelect"
                      preserveExpandStatus="false"
                      expandUniqueId="homeManagementTree"
                      v-bind:expandRootItem="expandRootItem"
                      ref="hmTree">
                </tree>
                <script id="homeManagementTreeViewTemplate" type="text/x-kendo-template">
                    <i class="fal fa-lg fa-cube"></i>
                    <span title="#=item.ToolTip#">#=item.Text#</span>
                    #if(item.Enabled){#
                    <i class="far fa-check-square"></i>#}#
                    #if(item.Root){#
                    <i class="far fa-home-alt"></i>#}#
                    #if(item.IconType==1){#
                    <i class="far fa-image"></i>#}#
                    #if(item.IconType==2){#
                    <i class="fas fa-flag"></i>#}#
                    #if(item.TopMenu){#
                    <i class="far fa-eye-slash"></i>#}#
                </script>

            </div>
            <div class="col-md-8" v-show="selectedItem">
                <div class="row">
                    <label class="radio">
                        <strong>{{$t("home_menu_management.menu_setting")}}</strong>
                    </label>
                </div>
                <fieldset>
                    <div class="row">
                        <input @change="showMenuChange" v-model="enabled" type="checkbox">{{$t("home_menu_management.show_menu")}}
                    </div>
                </fieldset>
                <fieldset :disabled="enabled===false">
                    <div class="row form-group">
                        <div class="col-md-6">
                            <input v-model="showInFirstLevel" type="checkbox">{{$t("home_menu_management.first_level")}}
                        </div>
                        <div class="col-md-6">
                            <input v-model="removeFromTopMenu" type="checkbox">{{$t("home_menu_management.not_show_top")}}
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col-md-12">
                            <label>{{$t("home_menu_management.display_name")}}</label>
                            <input v-model="displayText" type="text" class="form-control" />
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col-md-3">
                            <label class="radio">{{$t("home_menu_management.icon_view")}}</label>
                            <label class="radio">
                                <input type="radio" name="rbtDisplayIcon" value="0" v-model="displayIcon">
                                {{$t("home_menu_management.circul")}}
                            </label>
                            <label class="radio">
                                <input type="radio" name="rbtDisplayIcon" value="1" v-model="displayIcon">
                                {{$t("home_menu_management.squared")}}
                            </label>
                            <label class="radio">
                                <input type="radio" name="rbtDisplayIcon" value="2" v-model="displayIcon">
                                {{$t("home_menu_management.rectangle")}}
                            </label>
                        </div>
                        <div class="col-md-4">
                            <label class="radio">{{$t("home_menu_management.icon_width")}}</label>
                            <input v-model="iconWidth" type="text" class="form-control" @change="iconWidthChange" />
                        </div>
                        <div class="col-md-4">
                            <label class="radio">{{$t("home_menu_management.icon_height")}}</label>
                            <input v-model="iconHeight" type="text" class="form-control" :disabled="displayIcon!=2" @change="iconHeightChange" />
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col-md-3">
                            <label class="radio">{{$t("home_menu_management.text_location")}}</label>
                            <label class="radio">
                                <input type="radio" name="rbtTextPos" value="0" v-model="textPosition">
                                {{$t("home_menu_management.up_image")}}
                            </label>
                            <label class="radio">
                                <input type="radio" name="rbtTextPos" value="1" v-model="textPosition">
                                {{$t("home_menu_management.center_image")}}
                            </label>
                            <label class="radio">
                                <input type="radio" name="rbtTextPos" value="2" v-model="textPosition">
                                {{$t("home_menu_management.bottom_image")}}
                            </label>
                        </div>
                        <div class="col-md-4">
                            <label class="radio">{{$t("home_menu_management.home_menu_icon")}}</label>
                            <input type="file" id="fileDisplayIcon" @change="fileUploadChange" style="color:transparent;width:90px;">
                            <p class="help-block">{{$t("home_menu_management.select_file")}}</p>
                            Font Awesome icon: <input v-model="FAIcon" type="text" class="form-control">
                        </div>
                        <div class="col-md-4 admin">
                            <div class="col-md-6">
                                <a class="menu-item">
                                    <div id="upper-text" class="menu-text" v-show="textPosition==0">{{displayText}}</div>
                                    <div id="thumbView" class="menu-item-shape" :class="displayIcon==0 ? 'img-circle' : 'img-rounded'" :style="[imageData!==null ? { backgroundImage : 'url('+imageData+')' } : { backgroundImage : ''}]">
                                        <div id="middle-text" class="menu-text menu-text-middle" v-show="textPosition==1">{{displayText}}</div>
                                    </div>
                                    <div id="bottom-text" class="menu-text" v-show="textPosition==2">{{displayText}}</div>
                                </a>
                            </div>
                            <div class="col-md-6">
                                <button v-on:click="removePicture" style="margin-top:5px" class="btn btn-danger btn-xs">{{$t("home_menu_management.delete_image")}}</button>
                            </div>
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col-sm-4">
                            <label class="radio">{{$t("home_menu_management.text_color")}}</label>
                            <input id="textColor" type="text" class="form-control colorpicker" data-control="hue" style="direction: ltr" v-bind:placeholder='$t("home_menu_management.text_color")'>
                        </div>
                        <div class="col-sm-4">
                            <label class="radio">{{$t("home_menu_management.float_text_color")}}</label>
                            <input id="textColorHover" type="text" class="form-control colorpicker" data-control="hue" style="direction: ltr" v-bind:placeholder='$t("home_menu_management.float_text_color")'>
                        </div>
                        <div class="col-sm-4" style="display:none;">
                            <label class="radio">{{$t("home_menu_management.hilight_text_color")}}</label>
                            <input id="textColorHighlight" type="text" class="form-control colorpicker" data-control="hue" style="direction: ltr" v-bind:placeholder='$t("home_menu_management.hilight_text_color")'>
                        </div>
                    </div>
                </fieldset>
                <div class="row form-group">
                    <div class="col-md-1">
                        <button class="btn btn-success"
                                v-on:click="submit()">
                            {{$t("save")}}
                        </button>
                    </div>
                    <div class="col-md-4">
                        <button type="button"
                                class="btn btn-warning"
                                v-on:click="applyToAll"
                                v-bind:title='$t("home_menu_management.save_button_title")'
                                :disabled="enabled===false">
                            {{$t("home_menu_management.doing_settup")}}
                        </button>
                    </div>
                </div>
                <div class="row">
                    <br />
                    <span>
                        {{$t("attention")}} <br />
                        {{$t("page_refresh")}}
                    </span>
                </div>
            </div>
        </div>
    </newForm>
</template>
<script type="text/javascript">

    import NewForm from '../forms/newform/newForm.vue';
    import Tree from "../widgets/tree/tree.vue";

    export default {
        data() {
            return {
                direction: payload.currentLocale.IsRightToLeft,
                dataTree: [],
                treeTemp: null,
                selectedItem: false,
                enabled: false,
                showInFirstLevel: true,
                removeFromTopMenu: false,
                displayText: "",
                displayIcon: 0,
                iconWidth: 140,
                iconHeight: 140,
                textPosition: 1,
                items: {},
                imageData: null,
                lastId: "",
                isMenu: false,
                expandRootItem: true,
                FAIcon: "",
                IsFontAwesome: false
            }
        },
        methods: {
            removePicture() {
                this.imageData = null;
            },
            applyToAll() {
                var that = this;

                confirm(i18n.$t("home_menu_management.message.home_ui_save_confirm"), {
                    yes: function () {

                        var defaults = {};

                        defaults.IconWidth = that.iconWidth;
                        defaults.IconHeight = that.iconHeight;
                        defaults.TextPosition = that.textPosition;
                        defaults.IconShape = that.displayIcon;
                        defaults.TextColor = $("#textColor").val();
                        defaults.TextColorHover = $("#textColorHover").val();
                        defaults.TextColorHighlight = $("#textColorHighlight").val();

                        for (var key in that.items) {
                            that.items[key].IconHeight = defaults.IconHeight;
                            that.items[key].IconWidth = defaults.IconWidth;
                            that.items[key].TextPosition = defaults.TextPosition;
                            that.items[key].IconShape = defaults.IconShape;
                            that.items[key].TextColor = defaults.TextColor;
                            that.items[key].TextColorHover = defaults.TextColorHover;
                            that.items[key].TextColorHighlight = defaults.TextColorHighlight;
                        }

                        that.submit();
                    },
                    no: function () { }
                });
            },
            saveFormToItems(saveItem) {

                saveItem.Id = this.lastId;
                saveItem.Enabled = this.enabled;
                saveItem.Root = this.showInFirstLevel;
                saveItem.TopMenu = this.removeFromTopMenu;
                saveItem.DisplayName = this.displayText;
                saveItem.IconShape = this.displayIcon;
                saveItem.IconWidth = this.iconWidth;
                saveItem.IconHeight = this.iconHeight;
                saveItem.TextPosition = this.textPosition;
                saveItem.TextColor = $("#textColor").val();
                saveItem.TextColorHover = $("#textColorHover").val();
                saveItem.TextColorHighlight = $("#textColorHighlight").val();
                saveItem.ImageData = this.imageData;
                saveItem.IsMenu = this.isMenu;
                saveItem.FAIcon = this.FAIcon;
                this.items[this.lastId] = saveItem;
            },
            submit() {
                var that = this;

                confirm(i18n.$t("home_menu_management.message.save_confirm"), {
                    yes: function () {
                        var saveItem = that.items[that.lastId] || {};

                        that.saveFormToItems(saveItem);

                        let url = "api/home-management/save";

                        let data = [];

                        let callback = (result) => {
                            var params = {
                                text: that.$t('messages.sucsses_message'),
                                type: 'information',
                                layout: 'center',
                                timeout: 3000
                            };

                            noty(params);
                        };

                        for (var key in that.items)
                            data.push(that.items[key])

                        that.doAjaxRequest(url,
                            JSON.stringify(data),
                            callback,
                            () => { },
                            'POST');
                    },
                    no: function () { }
                });
            },
            iconHeightChange() {
                var val = parseInt(this.iconHeight);
                if (isNaN(val)) {
                    alert(i18n.$t("home_menu_management.message.insert_number"));
                    this.iconHeight = 140;
                    return;
                } else if (val < 25 || val > 140) {
                    alert(i18n.$t("home_menu_management.message.icon_size"));
                    this.iconHeight = 140;
                    return;
                }
            },
            iconWidthChange() {
                var val = parseInt(this.iconWidth);
                if (isNaN(val) === true) {
                    alert(i18n.$t("home_menu_management.message.insert_number"));
                    this.iconWidth = 140;
                    return;
                } else if (val < 25 || val > 300) {
                    alert(i18n.$t("home_menu_management.message.icon_size"));
                    this.iconWidth = 140;
                    return;
                }
            },
            showMenuChange() {
                this.$refs.hmTree.setProp(this.lastId, 'Enabled', this.enabled);
            },
            init() {
                this.enabled = false;
                this.showInFirstLevel = true;
                this.removeFromTopMenu = false;
                this.displayText = "";
                this.displayIcon = 0;
                this.iconWidth = 140;
                this.iconHeight = 140;
                this.textPosition = 1;

                var txtColor = $("#textColor");
                var textColorHover = $("#textColorHover");
                var textColorHighlight = $("#textColorHighlight");

                txtColor.val("#000000");
                textColorHover.val("#ADADAD");
                textColorHighlight.val("#DDDDDD");

                txtColor.trigger("keyup");
                textColorHover.trigger("keyup");
                textColorHighlight.trigger("keyup");

                this.imageData = null;
                this.FAIcon = "";
                this.IsFontAwesome = false;
            },
            fileUploadChange(e) {
                var that = this;
                var self = $("#fileDisplayIcon");
                function reset() {
                    self.wrap('<form>').parent('form').trigger('reset');
                    self.unwrap();
                }

                var reader = new FileReader();
                var file = self[0].files[0];

                if (file.type !== "image/png" && file.type !== "image/gif" && file.type !== "image/jpeg") {
                    alert(i18n.$t("home_menu_management.message.file_type"));
                    reset();
                    return;
                } else if (file.size > 30720) {
                    alert(i18n.$t("home_menu_management.message.icon_volume"));
                    reset();
                    return;
                }

                reader.onloadend = function () {
                    that.imageData = reader.result;
                    reset();
                }

                if (file) {
                    reader.readAsDataURL(file);
                }
            },
            nodeSelect(node, nodeData) {
                var nodeId = nodeData.Id;

                if (nodeId === this.lastId)
                    return;

                this.setSelectedNodeId = nodeId;

                var uiMenu = this.items[nodeId];

                if (this.selectedItem) {

                    var saveItem = this.items[this.lastId];

                    if (saveItem || this.enabled) {
                        saveItem = saveItem || {};

                        this.saveFormToItems(saveItem);
                    }
                }
                else {
                    this.selectedItem = true;
                }


                if (uiMenu) {
                    this.enabled = uiMenu.Enabled;

                    //if (uiMenu.ParentId == '00000000-0000-0000-0000-000000000000' || uiMenu.Root === true)
                    //    this.showInFirstLevel = true;
                    //else
                    //    this.showInFirstLevel = false;

                    this.showInFirstLevel = uiMenu.Root;
                    this.removeFromTopMenu = uiMenu.TopMenu;
                    this.displayText = uiMenu.DisplayName;
                    this.displayIcon = uiMenu.IconShape;
                    this.iconWidth = uiMenu.IconWidth;
                    this.iconHeight = uiMenu.IconHeight;
                    this.textPosition = uiMenu.TextPosition;
                    this.isMenu = uiMenu.IsMenu;

                    var txtColor = $("#textColor");
                    var textColorHover = $("#textColorHover");
                    var textColorHighlight = $("#textColorHighlight");

                    txtColor.val(uiMenu.TextColor);
                    textColorHover.val(uiMenu.TextColorHover);
                    textColorHighlight.val(uiMenu.TextColorHighlight);

                    txtColor.trigger("keyup");
                    textColorHover.trigger("keyup");
                    textColorHighlight.trigger("keyup");


                    if (uiMenu.IsFontAwesome)
                        this.imageData = null;
                    else
                        this.imageData = uiMenu.ImageData;

                    this.FAIcon = uiMenu.FAIcon;
                    this.IsFontAwesome = uiMenu.IsFontAwesome;

                } else {
                    this.init();
                    this.displayText = nodeData.Text;
                }

                this.lastId = nodeId;
                this.isMenu = nodeData.HasChildren;
            },
            doAjaxRequest(url, data, onSuccess, onFailure, method) {
                let ajaxConfig = {
                    url: url,
                    data: data,
                    dataType: "json",

                    contentType: "application/json;charset=utf-8"
                };
                ajaxConfig.beforeSend = (xhr) => {
                    xhr.setRequestHeader("__RequestVerificationToken", $("[name='__RequestVerificationToken']").val());
                };
                if (method) {
                    ajaxConfig.method = method;
                }
                $.ajax(ajaxConfig)
                    .done((result) => {
                        if (typeof onSuccess === 'function')
                            onSuccess(result);
                    }).error((error) => {
                        if (typeof onFailure === 'function') {

                            var response = null;

                            if (error.status == 400) {
                                response = JSON.parse(error.responseText);
                                onFailure(response);
                            }
                        }
                    });
            }
        },
        mounted() {
            this.treeTemp = $("#homeManagementTreeViewTemplate", this.$el).html();

            $(".colorpicker").each(function () {
                $(this).minicolors({
                    control: $(this).attr("data-control") || "hue",
                    defaultValue: $(this).attr("data-defaultValue") || "",
                    inline: $(this).attr("data-inline") === "true",
                    letterCase: $(this).attr("data-letterCase") || "uppercase",
                    opacity: $(this).attr("data-opacity"),
                    position: $(this).attr("data-position") || "top left",
                    change: function (hex, opacity) {
                        if (!hex) return;
                        if (opacity) hex += ", " + opacity;
                        if (typeof console === "object") {
                        }
                    },
                    theme: "bootstrap"
                });
            });
        },
        created() {

            var that = this;

            this.doAjaxRequest(
                "api/home-management", {},
                (data) => {

                    that.dataTree = data.tree;

                    for (var i = 0; i < data.menu.length; i++) {
                        var item = data.menu[i];
                        that.items[item.Id] = item;
                    }

                });
        },
        components: {
            NewForm,
            Tree
        }
    }

</script>
